export const cedenarValidURLs = [    
    "/webcedenar/principal/consola-componentes",
    "/webcedenar/principal/consola-componentes-no-regulados",
    "/webcedenar/principal/arbol-tarifario",
    "/webcedenar/principal/calculo-crpui",
    "/webcedenar/principal/opcion-tarifaria",
    "/webcedenar/principal/reliquidaciones",
    "/webcedenar/principal/publicar-tarifas",
    "/webcedenar/principal/alumbrado-publico",
    "/webcedenar/principal/publicacion-tarifas-no-regulados",
    "/webcedenar/principal/validacion-archivos",
    "/webcedenar/principal/validacion-archivos-no-regulados",
    "/webcedenar/principal/validacion-parametros",
    "/webcedenar/principal/validacion-parametros-no-regulados",
    "/webcedenar/principal/insumos-mes-de-calculo-no-regulados",
    "/webcedenar/principal/mercados",
    "/webcedenar/principal/mercados-no-regulados",
    "/webcedenar/principal/contratos-compra",
    "/webcedenar/principal/contratos-venta",
    "/webcedenar/principal/actores-financieros",
    "/webcedenar/principal/administracion-clientes-no-regulados",
    "/webcedenar/principal/metodologias-no-regulados",
    "/webcedenar/principal/portafolios-no-regulados",
    "/webcedenar/principal/contratos-no-regulados",
    "/webcedenar/principal/contratos-por-vencer-no-regulados",
    "/webcedenar/principal/balance-energetico", 
    "/webcedenar/principal/informe-comercializacion",
    "/webcedenar/principal/reportes-sui",
    "/webcedenar/principal/liquidacion-str",
    "/webcedenar/principal/tendencia-tarifas",
    "/webcedenar/principal/balance-portafolio-no-regulados",
    "/webcedenar/facturador/parametrizacion-comercializador",
    "/webcedenar/facturador/parametrizacion-ciclos",
    "/webcedenar/facturador/parametrizacion-mensual",
    "/webcedenar/facturador/parametrizacion-anual",
    "/webcedenar/facturador/parametrizacion-cuentas-bancarias",
    "/webcedenar/facturador/parametrizacion-operadores-de-red",
    "/webcedenar/facturador/parametrizacion-conceptos",
    "/webcedenar/facturador/parametrizacion-alumbrado-publico",
    "/webcedenar/facturador/parametrizacion-impuesto-seguridad",
    "/webcedenar/facturador/control-principal-clientes",
    "/webcedenar/facturador/compensaciones",
    "/webcedenar/facturador/cargar-consumos-ciclo",
    "/webcedenar/facturador/analisis-desviacion-significativa",
    "/webcedenar/facturador/informacion-consumos-cliente",
    "/webcedenar/facturador/liquidar-consumos",   
    "/webcedenar/facturador/liquidar-alumbrado",
    "/webcedenar/facturador/liquidar-impuesto-seguridad",
    "/webcedenar/facturador/cargar-otros-conceptos",
    "/webcedenar/facturador/conceptos-por-cliente",
    "/webcedenar/facturador/generar-facturas",
    "/webcedenar/facturador/reportes-internos",
    "/webcedenar/facturador/informes-auditoria",
    "/webcedenar/facturador/reportes-sui",
    "/webcedenar/facturador/cargar-info-agpe-gd",
    "/webcedenar/facturador/liquidar-agpe-dg",
    "/webcedenar/facturador/ajustes",
    "/webcedenar/facturador/asignacion-autorizaciones-hes",
    "/webcedenar/facturador/dashboard-liquidacion",
    "/webcedenar/autogeneradores/usuarios",
    "/webcedenar/autogeneradores/parametrizacion-precios-pactados",
    "/webcedenar/autogeneradores/parametrizacion-conceptos",
    "/webcedenar/autogeneradores/parametrizacion-ciclos",  
    "/webcedenar/autogeneradores/parametrizacion-causas-no-lectura",  
    "/webcedenar/autogeneradores/control-archivos",
    "/webcedenar/autogeneradores/consumos-cliente",
    "/webcedenar/autogeneradores/liquidacion-consumos",
    "/webcedenar/autogeneradores/reporte-usuario",
    "/webcedenar/autogeneradores/exportar-liquidacion",
    "/webcedenar/autogeneradores/informe-facturacion",
    "/webcedenar/autogeneradores/tendencia-facturacion",
    "/webcedenar/autogeneradores/reportes-xm",
    "/webcedenar/autogeneradores/consultas/panel-principal",
    "/webcedenar/autogeneradores/consultas/descargar-reporte",
    "/webcedenar/autogeneradores/consultas/estado-pago-excedentes",
    "/webcedenar/autogeneradores/consultas/comportamiento-estimado",
    "/webcedenar/tecnico-operativo/generar-orden",
    "/webcedenar/tecnico-operativo/rev-tecnica-acta-oficio",
    "/login",
]